import React from 'react';
import { Ellipsis, Page, PaginationContainer } from './styled';
import { getPaginationPages } from './helpers';
import { Arrow, ArrowDirection } from '../../../icons/Arrow';
import { PaginationProps, PaginationVariantEnum } from './types';
import { PaginationArrowButton } from './PaginationArrowButton';

export const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  totalPages,
  onPageChange,
  isPashaLanding,
  variant = PaginationVariantEnum.pasha
}) => {
  const handleClick = (page: number | string) => {
    if (typeof page === 'number' && page !== currentPage) {
      onPageChange(page);
    }
  };

  const isDefaultLightVariant = variant === PaginationVariantEnum.defaultLight;
  const ArrowComponent = isDefaultLightVariant ? PaginationArrowButton : Arrow;

  return (
    <PaginationContainer $isPashaLanding={isPashaLanding} $variant={variant}>
      <ArrowComponent
        disabled={currentPage === 1}
        onClick={() => currentPage > 1 && onPageChange(currentPage - 1)}
        direction={ArrowDirection.left}
      />
      {getPaginationPages(currentPage, totalPages).map((page, index) =>
        page === '...' ? (
          <Ellipsis key={index} $variant={variant}>
            …
          </Ellipsis>
        ) : (
          <Page
            key={index}
            $isActive={page === currentPage}
            onClick={() => handleClick(page)}
            $variant={variant}
          >
            {page}
          </Page>
        )
      )}
      <ArrowComponent
        disabled={currentPage === totalPages}
        onClick={() =>
          currentPage < totalPages && onPageChange(currentPage + 1)
        }
        direction={ArrowDirection.right}
      />
    </PaginationContainer>
  );
};

export default Pagination;
